var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"crm-card",class:{ active: _vm.active },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select')}}},[(_vm.tag)?_c('span',{staticClass:"crm-tag",class:_vm.tagClass},[_vm._v(_vm._s(_vm.tag))]):_vm._e(),_c('span',{staticClass:"crm-logo"},[_vm._v("Другое")])])
}
var staticRenderFns = []

export { render, staticRenderFns }